// extracted by mini-css-extract-plugin
export default {"shell":"Shell_shell__nWnxd"};